import { gql } from '@apollo/client';
import practiceAreaLookupFragment from './practiceAreaLookupFragment';

const GET_ORG_UNITS_DETAILED_REPORT = gql`
  query GetMddapOrgUnitDetailedReport($id: Int!) {
    detailedOrgUnitReport(id: $id) {
      Id
      Name
      Fei
      Address1
      Address2
      City
      State
      ZipCode
      EnrollmentDate
      AppraisalOrgUnits {
        Id
        Appraisal {
          Id
          Name
          ConductAppraisalEndDate
          AppraisalTeamLead {
            Id
            Individual {
              Id
              Name
            }
          }
          AppraisalTeamMembers {
            Individual {
              Id
              Name
            }
            Type
          }
          AppraisalOrgUnits {
            Id
            Name
            AppraisalOrgUnitProjects {
              Id
              Name
              Description
            }
            MddapOrgUnitId
            IsUserHasAccessOrgUnit
          }
        }
        AggregatePercentage
        AppraisalOrgUnitTargetPracticeAreas {
          Id
          AggregatePercentage
          PracticeArea {
            Id
            Name
            Acronym
          }
          PracticeGroup {
            Id
            Level
          }
        }
        AppraisalOrgUnitTargetPractices {
          Id
          CharacterizationsEvaluation
          Practice {
            Name
            NumberWithinLevel
          }
          PracticeGroup {
            Id
            Level
            PracticeArea {
              Id
            }
          }
        }
        AppraisalProgramYear
        ReappraisalRationaleDocument {
          Id
          FileName
          CheckpointId
        }
      }
      MddapOrganization {
        Id
        Name
      }
      MddapOfficeOfHealthTechnologies {
        Id
        OfficeOfHealthTechnology {
          Id
          Value
        }
      }
    }
    practiceAreas {
      ...PracticeAreaLookup
    }
    isPercentageVisible(orgUnitId: $id, reportName: "detailed-appraisal")
  }

  ${practiceAreaLookupFragment}
`;

export default GET_ORG_UNITS_DETAILED_REPORT;
